/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/rewardsfeedback/rewardsfeedback_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ REWARDS FEEDBACK : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const RewardsFeedback = (props) => {
	// Don't show rewards feedback if rewords are not enabled.
	// if(!props.rewardsSettings.enabled) { return null; }
	if(props.frameData === undefined) { return null }
	const rewardsEnabled = props.rewardsEnabled && props.rewardsPermitted && !!props.frameStatus.validRequest;
	// Dynamic variables.
    const frameType = props.frameData.type;
    const questionnaireType = frameType === 'profile' ? props.currentContentSettings.uniqueProps.questionnaireType.toLowerCase() : null;
    const type = frameType === 'quiz' ? props.frameStatus.isAnsweredCorrectly ? 'correct' : 'incorrect' : 'success'; // correct ::: incorrect ::: success
    const text = frameType === 'quiz' ? type === 'correct' ? 'Correct!' : 'Incorrect!' : 'Thanks!'; // Correct! ::: Incorrect ::: Thanks!
	// const text = 'pts awarded!'; // Correct! ::: Incorrect ::: Thanks!
	let pointsSettings = frameType === 'profile' ? 0 : props.rewardsPointValues[frameType];
	if (!!props.rewardsPointValues.profileQuestions && !!questionnaireType) {
		pointsSettings = props.rewardsPointValues.profileQuestions[questionnaireType];
	} else if (!!props.rewardsPointValues['profile']) {
		pointsSettings = props.rewardsPointValues[frameType];
	}
	const point = rewardsEnabled ? type !== 'incorrect' ? `+${pointsSettings}` : '+0' : type !== 'incorrect' ? '👍' : '👎' ; // 0 or +NumVal
	return(
		<div className={`${sheet.classes.rewardsfeedback} rewardsfeedback ${type} rewards-${rewardsEnabled} correct-${type !== 'incorrect'}`}>
			<span className={`icon`}>
				<span className={`value`}>
					<span className={`number ${point.length > 3 ? 'large' : 'normal'} `}>{point}</span>
					{/*<span className={`pts`}>{point === '+1' ? 'pt' : 'pts'}</span>*/}
				</span>
			</span>
			<span className={`text large-${props.enlargedFont}`}>{text}</span>
		</div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default RewardsFeedback;
